import PrizesList from "./PrizesList";
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import PrizeCreate from "./PrizeCreate";
import PrizeEdit from "./PrizeEdit";

export default {
    list: PrizesList,
    create: PrizeCreate,
    edit: PrizeEdit,
    icon: EmojiEventsIcon
}
